/***
 * array of data to sort compliances by reason
 */
export const MOTIF_TYPES =[
        { value: null, text: "--Motif de contrôles--"},
        { value: "separtif", text: "Séparatif" },
        { value: "mutation", text:"Mutation"},
        { value: "nd", text: "ND" },
        { value: "other", text: "Autre" },
];
